class TabComponent extends HTMLElement {
  constructor() {
    super();
    this.onTabClick = this.onTabClick.bind(this);
    this.buttons = this.querySelectorAll("button[data-tab]");
  }

  connectedCallback() {
    this.setupTabs();
  }

  setupTabs() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onTabClick);
    });

    this.activateTab(this.buttons[0]);
  }

  onTabClick(event) {
    this.activateTab(event.target);
  }

  activateTab(tabButton) {
    this.buttons.forEach((button) => {
      button.setAttribute("aria-selected", "false");
      button.classList.remove("active");
    });

    // Hide all tab panels
    this.querySelectorAll(".tab-content").forEach((panel) => {
      panel.classList.remove("active");
      this.dataset.activeTab = "1";
    });

    // Activate the clicked tab and show the associated panel
    tabButton.setAttribute("aria-selected", "true");
    tabButton.classList.add("active");
    const panel = this.querySelector(
      `.tab-content[data-tab="${tabButton.dataset.tab}"]`
    );

    if (panel) {
      panel.classList.add("active");
      this.dataset.activeTab = tabButton.dataset.tab;
    }
  }
}

customElements.define("tab-component", TabComponent);
